import { cn } from '@/shadcn-ui/utils';
import { fullstoryEvent } from '@/fullstory/utils/fullstory-event';
import { useEffect } from 'react';
import CalculatorSalesPitch from './sales-pitch/calculator-sales-pitch';
import CalculatorSalesPitchV2 from './sales-pitch/calculator-sales-pitch-v2';
import VehicleDetailsSalesPitch from './sales-pitch/vehicle-details-sales-pitch';

export interface PDPSalesPitchProps {
  PUBLIC_CDN_URL: string;
  totalSavings?: number;
  savingsCalculatorAvailable?: boolean;
  buyingUpfront?: number;
  buyingMonthlyCar?: number;
  buyingMonthlyInsurance?: number;
  flexcarUpfront?: number;
  flexcarMonthlyCar?: number;
  flexcarMonthlyInsurance?: number;
  flexcarShippingCost?: number;
  flexcarNewCarSurcharge?: number;
  flexcarMembershipCost?: number;
  handleOpen: () => void;
}

export default function PDPSalesPitch({
  PUBLIC_CDN_URL,
  totalSavings,
  savingsCalculatorAvailable,
  buyingUpfront,
  buyingMonthlyCar,
  buyingMonthlyInsurance,
  flexcarUpfront,
  flexcarMonthlyCar,
  flexcarMonthlyInsurance,
  flexcarShippingCost,
  flexcarNewCarSurcharge,
  flexcarMembershipCost,

  handleOpen,
}: PDPSalesPitchProps) {
  const showSavings = totalSavings && totalSavings > 0;
  const showSavingsCalculatorV2 = !!savingsCalculatorAvailable;

  useEffect(() => {
    if (!totalSavings) {
      fullstoryEvent('calculate_your_savings_missing_data');
    } else if (totalSavings <= 0) {
      fullstoryEvent('calculate_your_savings_flexcar_more_expensive');
    }
  }, [totalSavings]);

  return (
    <div
      className={cn(
        'relative top-[-16px] w-[calc(100%-32px)] overflow-hidden rounded-3xl bg-[linear-gradient(50deg,_#FEF2FE_0%,_white_50%)] lg:top-0 lg:w-[424px]',
        {
          'bg-white': showSavings && !showSavingsCalculatorV2,
          'bg-[linear-gradient(37.15deg,_#71D9D5_-10.58%,_#D2C6F7_80.75%,_#F9DCDB_116.15%)] p-[1px]':
            showSavingsCalculatorV2,
          'w-[calc(100%-32px)]': showSavings || showSavingsCalculatorV2,
          'w-full': !showSavings && !showSavingsCalculatorV2,
        }
      )}
    >
      {showSavings && !showSavingsCalculatorV2 && totalSavings ? (
        <CalculatorSalesPitch
          isOnPDP={true}
          totalSavings={totalSavings}
          handleOpen={handleOpen}
        />
      ) : null}
      {showSavingsCalculatorV2 &&
      buyingUpfront !== undefined &&
      buyingMonthlyCar !== undefined &&
      buyingMonthlyInsurance !== undefined &&
      flexcarUpfront !== undefined &&
      flexcarMonthlyCar !== undefined &&
      flexcarMonthlyInsurance !== undefined ? (
        <CalculatorSalesPitchV2
          isOnPDP={true}
          handleOpen={handleOpen}
          PUBLIC_CDN_URL={PUBLIC_CDN_URL}
          buyingUpfront={buyingUpfront}
          buyingMonthlyCar={buyingMonthlyCar}
          buyingMonthlyInsurance={buyingMonthlyInsurance}
          flexcarUpfront={flexcarUpfront}
          flexcarMonthlyCar={flexcarMonthlyCar}
          flexcarMonthlyInsurance={flexcarMonthlyInsurance}
          flexcarShippingCost={flexcarShippingCost}
          flexcarNewCarSurcharge={flexcarNewCarSurcharge}
          flexcarMembershipCost={flexcarMembershipCost}
        />
      ) : null}

      {!showSavings && !showSavingsCalculatorV2 ? <VehicleDetailsSalesPitch /> : null}
    </div>
  );
}
